var _circle, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgElement1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.16,
    cx: 55.7229,
    cy: 55.7229,
    r: 55.7229,
    fill: "url(#paint0_linear_10848_6483)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.723 74.4379C66.0589 74.4379 74.4378 66.059 74.4378 55.7231C74.4378 45.3872 66.0589 37.0083 55.723 37.0083C45.3871 37.0083 37.0082 45.3872 37.0082 55.7231C37.0082 66.059 45.3871 74.4379 55.723 74.4379ZM55.723 85.9237C72.4023 85.9237 85.9236 72.4025 85.9236 55.7231C85.9236 39.0437 72.4023 25.5225 55.723 25.5225C39.0436 25.5225 25.5223 39.0437 25.5223 55.7231C25.5223 72.4025 39.0436 85.9237 55.723 85.9237Z",
    fill: "url(#paint1_linear_10848_6483)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10848_6483",
    x1: 4.96223,
    y1: 17.8516,
    x2: 95.6746,
    y2: 96.3787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02C8C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02C8C6",
    stopOpacity: 0.13
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10848_6483",
    x1: 65.4033,
    y1: 72.3812,
    x2: 36.2174,
    y2: 38.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02C8C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02C8C6",
    stopOpacity: 0.19
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgElement1);
export default __webpack_public_path__ + "static/media/bg_element1.7e905a6fb7f1635495f738b93237b730.svg";
export { ForwardRef as ReactComponent };